// removed by extract-text-webpack-plugin
module.exports = {"tooltip":"HSD0e","tooltip_trigger":"B5DJM","tooltip_bubble":"_3daiq","tooltip-top":"_2o1rB","tooltip-bottom":"_2cp1S","tooltip-left":"_1MMC3","tooltip-right":"TLwQS","tooltip_message":"KKrPg"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Tooltip/Tooltip.css
// module id = 828
// module chunks = 0